import find from 'lodash/find'

import {
  IProjectVersionAttributes,
} from '@SiteModules/ProjectVersion/types'

import {
  ISubtitle,
} from '@SiteModules/Subtitle/types'

export default function getShouldAllowToGenerateClips(projectVersionAttributes: IProjectVersionAttributes, subtitles: ISubtitle[]): boolean {
  const {
    hasMainAssets,
    isShortened,
    belongsToTtsProject,
    isDisabled,
    duration,
    status,
  } = projectVersionAttributes

  const hasNoSubtitles = subtitles.length === 0
  const transcript = find(subtitles, subtitle => subtitle.attributes.transcription)
  const transcriptIsCompleted = !!transcript && transcript.attributes.stage === 'done'

  const durationNotYetDetermined = duration === '00:00' && status === 'downloading'
  const shouldAllowToGenerateClips = !isDisabled &&
    hasMainAssets &&
    !belongsToTtsProject &&
    !isShortened &&
    !durationNotYetDetermined &&
    (hasNoSubtitles || transcriptIsCompleted)

  return shouldAllowToGenerateClips
}
